/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Wizard_TitleInputs */

const cs_portals_wizard_title = /** @type {(inputs: Portals_Wizard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojit Sreality, RealityMIX a iDNES`)
};

const en_portals_wizard_title = /** @type {(inputs: Portals_Wizard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Sreality, RealityMIX, and iDNES`)
};

/**
* | output |
* | --- |
* | "Connect Sreality, RealityMIX, and iDNES" |
*
* @param {Portals_Wizard_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_wizard_title = /** @type {((inputs?: Portals_Wizard_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Wizard_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_wizard_title(inputs)
	return cs_portals_wizard_title(inputs)
});